import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import modelHistoryStore from './store';
import { SVGPureIcon } from '@/ui';
import urlStore from '@/store/chat/urlStore';
import Loader from '@/common/helper/loader';
import EE from '@/common/event';

const ModelHistory = ({ className = '' }) => {
  const isNeedSlice =
    modelHistoryStore.isFold || !modelHistoryStore.loadSecondPage;

  // 多端同步 - 机器人会话历史
  const handleHistory = (data) => {
    console.log('多端同步 - 模型', data);
    modelHistoryStore.getModelList({ size: 10, first: true });
  }
  useEffect(() => {
    EE.on("assistant_history", handleHistory);
    modelHistoryStore.reset()
    modelHistoryStore.getModelList({ size: modelHistoryStore.firstPageSize, first: true });
    return () => {
      EE.off("assistant_history", handleHistory);
      modelHistoryStore.reset()
    }
  }, []);

  if (!modelHistoryStore.listData.length) return;

  return (
    <div className={['', className]}>
      {(isNeedSlice
        ? modelHistoryStore.listData.slice(0, 3)
        : modelHistoryStore.listData
      ).map((item, index) => {
        if(!item)return null
        return (
          <div
            key={index}
            onClick={evt => {
              urlStore.newChat({ roleId: item.id });
            }}
            className="flex items-center mb-8px h-44px pl-6px pr-2px rounded-8px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer"
          >
            <div className="size-32px mr-12px rounded-full overflow-hidden border-1px border-[rgba(0,0,0,0.06)]">
              <img src={Loader.getModelIcon(item)} className="size-full object-contain" alt="" />
            </div>

            <span className="flex-grow w-0 h-44px leading-44px truncate text-16px text-black">
              {item?.title}
            </span>
          </div>
        );
      })}
      {modelHistoryStore.npt || modelHistoryStore.isFold ? (
        <div
          onClick={evt => {
            if (modelHistoryStore.npt) {
              modelHistoryStore.getModelList({ size: 10 });
            } else {
              modelHistoryStore.setFold(false);
            }
          }}
          className="flex items-center h-44px pl-6px pr-2px rounded-12px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer"
        >
          <div className="size-32px mr-12px rounded-full overflow-hidden border-1px bg-[rgba(0,0,0,0.04)]">
            <SVGPureIcon
              name="model_more"
              className="w-16px ml-8px transform rotate-180"
            />
          </div>
          <span className="text-16px">更多</span>
        </div>
      ) : (
        <div
          onClick={evt => {
            modelHistoryStore.setFold(true);
          }}
          className="flex items-center h-44px pl-6px pr-2px rounded-12px hover:bg-[rgba(0,0,0,0.03)] cursor-pointer"
        >
          <div className="size-32px mr-12px rounded-full overflow-hidden border-1px bg-[rgba(0,0,0,0.04)] ">
            <SVGPureIcon
              name="model_fold"
              className="w-16px ml-8px transform "
            />
          </div>
          <span className="text-16px">折叠</span>
          
        </div>
      )}
    </div>
  );
};

export default observer(ModelHistory);
